import { useNavigate } from "react-router-dom";
import { UserContext } from "../context/UserContext";
import { AlertContext } from "../context/AlertContext";
import { useContext, useState } from "react";

import API from "../api/api"; 
import "../css/Hero.css";

type RankingAmigo = {
  id: number;
  nombre: string;
  puntos: number;
  posicion: number;
};

type HeroProps = {
  rankingGlobal: {
    top9: { id: number; nombre: string; puntos: number }[];
    yo: { id: number; nombre: string; puntos: number; posicion: number } | null;
  };
  rankingAmigos?: {
    ranking: RankingAmigo[];
    yo: RankingAmigo | null;
  } | null;
  onInvitar: () => void;
  onSolicitudes: () => void;
};



const Hero = ({ rankingGlobal, rankingAmigos, onInvitar, onSolicitudes }: HeroProps) => {
  const { user } = useContext(UserContext) ?? { user: null };
  const { showAlert } = useContext(AlertContext) ?? { showAlert: () => {} };
  const navigate = useNavigate();
const [mostrarConfirm, setMostrarConfirm] = useState(false);

  const requireLogin = (action: () => void, message = "Iniciá sesión para continuar ⚽") => {
    if (!user) {
      showAlert(message, "info");
      navigate("/login");
      return;
    }
    action();
  };

  const handleSalir = async () => {
  await API.delete(`/grupos/salir/${user?.id}`);
  showAlert("Saliste del grupo 👋", "info");
  navigate(0);

};

return (
  <>
    <section className="hero-container">
      <div className="hero-image-container">
        <h1 className="hero-title">
          MUNDIAL 2026. PREDICE, GANA PUNTOS, JUEGA CON AMIGOS.
        </h1>
        <img src="/copa3.webp" className="hero-copa" alt="Copa Mundial 2026" />
      </div>

      <div className="hero-rankings">

        {/* Ranking mundial */}
        <div className="hero-card">
          <h3>🌍 Ranking Mundial</h3>
          <ul>
            {(rankingGlobal?.top9 || []).map((u, i) => (
            <li key={u.id}>
              {i + 1}. {u.nombre} <strong>{u.puntos} pts</strong>
            </li>
          ))}

            {rankingGlobal.yo && (
              <li className="mi-posicion" style={{ marginTop: 15, fontSize: "18px" }}>
                🔥#{rankingGlobal.yo.posicion} mundial
                <strong> {rankingGlobal.yo.puntos} pts</strong>
              </li>
            )}
          </ul>
        </div>

        {/* Ranking amigos */}
        {user ? (
          <div className="hero-card">
            <h3>👥 Ranking de Amigos</h3>

            {rankingAmigos?.ranking && rankingAmigos.ranking.length > 0 ? (
              <>
                <ul>
                  {rankingAmigos.ranking.map((u) => (
                    <li key={u.id}>
                      {u.posicion}. {u.nombre} <strong>{u.puntos} pts</strong>
                    </li>
                  ))}
                </ul>

                <button
                  className="btn-salir"
                  onClick={() => setMostrarConfirm(true)}
                >
                  Salir del grupo
                </button>
              </>
            ) : (
              <p>Todavía no tenés amigos en el grupo.</p>
            )}

            <div className="hero-actions">
              <button onClick={onInvitar}>Invitar amigos</button>
              <button onClick={onSolicitudes}>Solicitudes</button>
            </div>
          </div>
        ) : (
          <div className="hero-card hero-login-card">
            <h3>¿Listo para competir?</h3>
            <p>Iniciá sesión para invitar competir con tus amigos.</p>
            <button
              className="login-btn-hero"
              onClick={() => navigate("/login")}
            >
              Iniciar sesión
            </button>
          </div>
        )}
      </div>
    </section>

    {/* MODAL */}
    {mostrarConfirm && (
      <div className="modal-overlay">
        <div className="modal">
          <h4>¿Salir del grupo?</h4>
          <p>Vas a perder el acceso al ranking de amigos.</p>

          <div className="modal-actions">
            <button onClick={() => setMostrarConfirm(false)}>
              Cancelar
            </button>

            <button
              className="btn-danger"
              onClick={() => {
                handleSalir();
                setMostrarConfirm(false);
              }}
            >
              Sí, salir
            </button>
          </div>
        </div>
      </div>
    )}
  </>
);

};

export default Hero;